import * as React from "react";
import { Bug } from "lucide-react";
import { Button } from "../Button";
import { FeedbackModal } from "./FeedbackModal";

interface FeedbackButtonProps {
  isAuthenticated?: boolean;
}

export function FeedbackButton({ isAuthenticated = false }: FeedbackButtonProps) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button variant="ghost" size="sm" className="gap-2" onClick={() => setOpen(true)}>
        <Bug className="size-4" />
        Submit Feedback
      </Button>
      {open && <FeedbackModal isAuthenticated={isAuthenticated} onClose={() => setOpen(false)} />}
    </>
  );
}
